import React from "react";
import { useAppState } from "../state/AppStateContext";
import { t } from "../i18n/strings";

export default function EditProfileSheet() {
  const { editOpen, closeEdit, draftName, draftArea, setDraftName, setDraftArea, saveEdit, lang } = useAppState();

  if (!editOpen) return null;

  return (
    <div onClick={closeEdit} style={styles.backdrop}>
      <div onClick={(e) => e.stopPropagation()} style={styles.sheet}>
        <div style={styles.handle} />
        <h4 style={styles.title}>{t(lang, "editDetails")}</h4>

        <div className="field" style={{ marginBottom: 14 }}>
          <label>{t(lang, "yourName")}</label>
          <input
            className="input"
            value={draftName}
            onChange={(e) => setDraftName(e.target.value)}
            placeholder={t(lang, "yourName")}
            style={{ height: 52, fontSize: 16 }}
          />
        </div>

        <div className="field" style={{ marginBottom: 18 }}>
          <label>{t(lang, "homeTaxiRank")}</label>
          <input
            className="input"
            value={draftArea}
            onChange={(e) => setDraftArea(e.target.value)}
            placeholder={t(lang, "homeTaxiRankPlaceholder")}
            style={{ height: 52, fontSize: 16 }}
          />
        </div>

        <button type="button" className="btn btn-primary btn-block" onClick={saveEdit} style={{ height: 54, fontSize: 16 }}>
          {t(lang, "save")}
        </button>
      </div>
    </div>
  );
}

const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    zIndex: 41,
    background: "rgba(4,12,20,.6)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  sheet: {
    background: "var(--color-surface)",
    borderRadius: "28px 28px 0 0",
    padding: "20px 18px 30px",
    animation: "sheetUp .3s ease",
  },
  handle: { width: 44, height: 5, borderRadius: 999, background: "var(--color-neutral-600)", margin: "0 auto 16px" },
  title: { fontSize: 21, margin: "0 0 14px" },
};
